
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ai-helpdesk-software",
      function () {
        return require("private-next-pages/solutions/ai-helpdesk-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ai-helpdesk-software"])
      });
    }
  